import { Avatar, ListItemIcon, MenuItem, PaperProps, Stack, Typography, styled } from '@mui/material'
import { Flex } from '../../styles/flexComponent'

export const StyledMenuItem = styled(MenuItem)`
  padding: 10px 16px;
  gap: 12px;
  align-items: center;
  &:hover {
    background-color: ${props => props.theme.palette.action.hover};
  }
`

export const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 40px;
  justify-content: center;
  align-items: center;
`

export const StyledMenuItemTypography = styled(Typography)`
  font-weight: 500;
`

export const TopBarIcons = styled(Stack)`
  padding: 4px;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background-color: ${props => props.theme.palette.lightGray[props.theme.palette.mode]};
    border-radius: 100%;
  }
  svg {
    height: 32px;
    width: 32px;
  }
  img {
    height: 32px;
    width: 28px;
    margin-left: 5px;
  }
`

export const NavigationContainer = styled(Flex.Row)<{ $active: boolean }>`
  border-bottom: ${props => (props.$active ? '3px solid ' + props.theme.palette.primary[props.theme.palette.mode] : 0)};
  color: ${props =>
    props.$active
      ? props.theme.palette.primary[props.theme.palette.mode]
      : props.theme.palette.black[props.theme.palette.mode]};
  padding: 8px 14px 14px 14px;
  cursor: pointer;
`
export const NavigationColumnContainer = styled(Flex.Row)<{ $active: boolean }>`
  border-bottom: ${props => (props.$active ? '1px solid ' + props.theme.palette.primary[props.theme.palette.mode] : 0)};
  color: ${props =>
    props.$active
      ? props.theme.palette.primary[props.theme.palette.mode]
      : props.theme.palette.black[props.theme.palette.mode]};
  padding: 5px 0px 0px 0px;
  cursor: pointer;
`

export const LogoContainer = styled(Flex.Row)`
  flex: 1;
`
export const ProfileAvatar = styled(Avatar)`
  width: 30;
  height: 30;
  font-size: 14px;
`

export const PaperProperties: PaperProps = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    paddingx: 10,
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 28,
      height: 28,
      fontSize: 13,
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
    },
  },
}
